// export default [
//   {
//     title: 'Model Test',
//     icon: 'LayersIcon',
//     tag: '2',
//     tagVariant: 'light-warning',
//     children: [
//       {
//         title: 'Live',
//         route: 'model_test_live_list_by_category',
//         menu_class: 'btn btn-danger btn-sm',
//       },
//       {
//         title: 'All',
//         route: 'model_test_all_category',
//       }
//     ],
//   }
// ]
export default [
  {
    title: 'Live Model Test',
    icon: 'LayersIcon',
    route: 'model_test_live_list_by_category',
    menu_class: 'btn btn-danger btn-sm',
  }
]
